<template>
  <a-modal
    :title="addressType === 1?'寄件地址库':'收件地址库'"
    :visible.sync="visible"
    :width="700"
    @cancel="cancel"
  >
    <div>
      <div class="mb-20">
        <div v-for="i in list" :key="i.id" class="flex flex-j-sb a-center h-32">
          <a-checkbox v-model="i.check" @change="change(i)">
            <span class="w-300 inline-block text-over v-t-b">{{ $utils.formatAddr(i) }}</span><span class="w-50 inline-block text-over ml-16  mr-16 v-t-b">{{ i.contactName }}</span><span class="inline-block v-t-b">{{ i.mobile }}</span>
          </a-checkbox>
          <div class="flex">
            <div v-if="i.isDefault" class="pointer pr-16">[默认地址]</div>
            <a-button v-else-if="addressType == 1" type="link" @click="setDefault(i)">设为默认</a-button>
          </div>
        </div>
        <a-empty v-if="list.length===0" />

      </div>
      <a-pagination v-if="pagination.totalSize>pagination.pageSize" v-model="pagination.pageIndex" :total="pagination.totalSize" show-less-items @change="pageChange" />
    </div>
    <AddrForm v-if="showForm" class="mt-20" :address-type="addressType" @cancel="formcancel" @success="addSuccess" />
    <div slot="footer" class="t-right"><a-button :disabled="!canAdd" @click="add">新 增</a-button> <a-button type="primary" :disabled="!canConfirm" @click="confirm">确 认</a-button></div>
  </a-modal>
</template>
<script>
import AddrForm from './addrForm'
export default {
  components: {
    AddrForm
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    addressType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
    //   visible: true
      showForm: false,
      canAdd: true,
      list: [],
      pagination: {
        pageIndex: 1,
        totalSize: 0,
        pageSize: 10
      }
    }
  },
  computed: {
    canConfirm() {
      return this.list.find(el => el.check)
    }
  },
  watch: {
    async visible(n) {
      if (n) {
        await this.getAddrList()
      }
    }
  },
  methods: {
    formcancel() {
      this.showForm = false
      this.canAdd = true
    },
    add() {
      this.showForm = true
      this.canAdd = false
    },
    cancel() {
      this.$emit('update:visible', false)
    //
    },
    change(i) {
      this.list.forEach((it) => {
        it.check = false
      })
      i.check = true
    },
    addSuccess() {
      this.$message.success('添加成功')
      this.canAdd = true
      this.showForm = false
      this.getAddrList()
    },
    async getAddrList() {
      const res = await this.$http(this.$api.addressGetPageList, {
        'pageIndex': this.pagination.pageIndex,
        'pageSize': this.pagination.pageSize,
        addressType: this.addressType
      })
      res.list.forEach((it) => {
        if (it.isDefault) {
          it.check = true
        } else {
          it.check = false
        }
      })
      this.list = res.list
      this.pagination.totalSize = res.totalSize
    },
    async setDefault(i) {
      const res = await this.$http({ ...this.$api.addressUpdate, origin: true }, {
        id: i.id,
        isDefault: 1,
        addressType: 1
      })
      if (res.data.state === 'success') {
        this.pagination.pageIndex = 1
        await this.getAddrList()
      } else {
        this.$message.error(res.data.msg)
      }
    },
    pageChange(page) {
      this.pagination.pageIndex = page
      this.getAddrList()
    },
    confirm() {
      this.$emit('update:visible', false)
      const selected = this.list.find(el => el.check)
      this.$emit('ok', { ...selected })
    }
  }
}
</script>
